import { call, put } from 'redux-saga/effects';
import ERRORS from 'constants/errors';
import STEPS from 'constants/steps';
import { createLogger } from 'helpers/logger';
import { setError, startLoading, stopLoading, setStep } from 'reduxConfig/auth.creators';

const log = createLogger('[auth-saga]');

export function* authEmailVerificationReturn({ actionCode }) {
  yield put(startLoading());
  try {
    yield call(window.FIREBASE.applyActionCode, actionCode);

    window.dataLayer?.push({
      event: 'email_verification_complete'
    });

    yield put(setStep(STEPS.verifyEmailComplete));
  } catch (error) {
    log.info('Receive email verification error:', error); // eslint-disable-line
    if (error.code === 'auth/invalid-action-code') {
      yield put(setError(ERRORS.emailNotVerifiedReturnInvalidActionCode));
    } else {
      yield put(setError(ERRORS.emailNotVerifiedReturnGeneric));
    }
  } finally {
    yield put(stopLoading());
  }
}
